import { NpoPaymentAccountStepsResult } from '@/api/models/paymentAccountsModels';
import { NPO_ONBOARDING_STEPS, NpoMerchantOnboardingRoutes } from '@/constants/enums/NpoMerchantOnboardingRoutes';

export function getNextIncompleteStep(data: NpoPaymentAccountStepsResult | null): NpoMerchantOnboardingRoutes {
  if (data === null || !data.acceptTOS) return NpoMerchantOnboardingRoutes.ACH_TERMS;

  if (data.allStepsSaved && !data.hasNuveiAccount) return NpoMerchantOnboardingRoutes.BANK_ACCOUNT;
  if (data.allStepsSaved && data.hasNuveiAccount) return NpoMerchantOnboardingRoutes.DOCUMENTS;

  const currentIndex = NPO_ONBOARDING_STEPS.findLastIndex((step) => step.completed(data));

  const nextStep =
    NPO_ONBOARDING_STEPS[currentIndex !== NPO_ONBOARDING_STEPS.length - 1 ? currentIndex + 1 : currentIndex] ?? null;

  return nextStep?.route ?? NpoMerchantOnboardingRoutes.ACH_TERMS;
}
